import { rem } from 'polished';
import styled from 'styled-components';

import mediaqueries from '../../../config/themes/variables/mediaqueries';
import Icon from '../Icon';
import IconPng from '../Icon/indexPng';

const StyledTitle = styled.h2`
  font-size: ${props => (props.small ? rem('16px') : rem('24px'))};
  font-family: ${props => props.theme.fonts.bold};
  text-transform: uppercase;
  cursor: pointer;
  color: ${props => props.theme.colors.dark};
  margin-bottom: 0;
  padding-right: ${rem('10px')};
  height: ${props => (props.small ? rem('32px') : rem('40px'))};
  display: inline-block;
  line-height: ${props => (props.small ? rem('23px') : rem('40px'))};
  padding-left: ${props => (props.small ? rem('40px') : rem('50px'))};
  margin-left: ${rem('25px')};
  letter-spacing: ${rem('-0.8px')};
  position: relative;

  ${mediaqueries.lessThan('mobile')`
    font-size: ${rem('15px')};
    height: ${rem('30px')};
    line-height: ${rem('30px')};
    padding-left: ${rem('42px')};
    padding-right: ${rem('20px')};
  `};

  ${mediaqueries.greaterThan('desktop')`
    font-size: ${props => (props.small ? rem('20px') : rem('24px'))};
    line-height:  ${props => (props.small ? rem('32px') : rem('40px'))};
  `};
  ${props =>
    props.type === 'agenda' &&
    `  background-color: ${props.theme.colors.colorOne};
    `};
  ${props =>
    props.type === 'audiences' &&
    `  background-color: ${props.theme.colors.colorTwo};
    `};
  ${props =>
    props.type === 'digitalaudiences' &&
    `  background-color: ${props.theme.colors.colorSix};
    `};
  ${props =>
    props.type === 'audiencesradio' &&
    `  background-color: ${props.theme.colors.colorFive};
    `};
  ${props =>
    props.type === 'ranking' &&
    `  background-color: ${props.theme.colors.colorTwo};
    `};
  ${props =>
    props.type === 'resumen' &&
    `  background-color: ${props.theme.colors.colorSix};   
    `};
  ${props =>
    props.type === 'menuofday' &&
    `  background-color: ${props.theme.colors.colorThree};
    `};
  ${props =>
    props.type === 'shortcut' &&
    `  background-color: ${props.theme.colors.colorSix};
    `};
  ${props =>
    props.type === 'pressrelease' &&
    `  background-color: ${props.theme.colors.colorOne};
    `};
  ${props =>
    props.type === 'employeeDirectory' &&
    `  background-color: ${props.theme.colors.colorOne};
    `};
  ${props =>
    props.type === 'myNotifications' &&
    `  background-color: ${props.theme.colors.colorThree};
    `};
  ${props =>
    props.type === 'ondacero' &&
    `  background-color: #2E824C ;
    `};
  ${props =>
    props.type === 'md3' &&
    `  background-color: ${props.theme.colors.colorThree};
    `};
  ${props =>
    props.type === 'periodismo' &&
    `  background-color: ${props.theme.colors.colorThree};
       height: ${rem('75px')};
    `};
  ${mediaqueries.lessThan('mobile')`
    ${props => props.type === 'periodismo' && `height: ${rem('60px')};`}
  `};
  ${props =>
    props.type === 'plata' &&
    `  background-color: ${props.theme.colors.colorPlata};
    `};
  ${props =>
    props.type === 'strategy' &&
    `  background-color: ${props.theme.colors.colorThree};
    `};
  ${props =>
    props.type === 'twitter' &&
    `  background-color: #00acee ;
    `};
  ${props =>
    props.type === 'instagram' &&
    `  background-color: #f09433 ;
    `};
  ${props =>
    props.type === 'zerowaste' &&
    `margin-left: 2.15rem;
    background-color: ${props.theme.colors.colorTwo};
    `};
  ${props =>
    props.type === 'oraclehcm' &&
    `color: #DB3C22;
    padding-top: 0.125rem;
    padding-left: 8.125rem;
    text-transform: lowercase;
    `};
  ${props =>
    props.type === 'rrssaudiencia' &&
    `background-color: ${props.theme.colors.colorFour};
    `};
  ${props =>
    props.type === 'customWidget' &&
    `margin-left: 2.15rem;
    background-color: ${props.theme.colors.colorThree};
    `};
`;

const StyledIcon = styled(Icon)`
  position: absolute;
  left: ${rem('-22px')};
  ${props =>
    props.type === 'audiences' &&
    ` bottom: ${props.small ? rem('-6px') : rem('-11px')};
      width: ${props.small && rem('51px')};
  `};
  ${props =>
    props.type === 'ranking' &&
    ` bottom: ${props.small ? rem('-6px') : rem('-11px')};
      width: ${props.small && rem('51px')};
  `};
  ${props =>
    props.type === 'pressrelease' &&
    ` bottom: ${rem('-6px')};
      width: ${rem('54px')};
  `};
  ${props =>
    props.type === 'menuofday' &&
    `bottom:${rem('-9px')};
     width:${rem('64px')};
     height:${rem('64px')};
     left: ${rem('-23px')};
  `};
  ${props =>
    props.type === 'resumen' &&
    ` top: ${props.small ? rem('-6px') : rem('-13px')};
      width: ${props.small && rem('51px')};
  `};
  ${props =>
    props.type === 'shortcut' &&
    ` top:${rem('-9px')};
  `};
  ${props =>
    props.type === 'agenda' &&
    `background-color: ${props.theme.colors.light};
    top:${rem('-6px')};
  `};
  ${props =>
    props.type === 'zerowaste' &&
    `margin-left: -1rem;
      margin-top: -1rem;
      width: 4rem;
      height: 4rem;
  `};
  ${props =>
    props.type === 'oraclehcm' &&
    `top: -2rem;
    left: -3.5rem;
    width: 13rem;
    height: 7rem;
  `};
  ${props =>
    props.type === 'customWidget' &&
    `margin-left: -0.75rem;
      margin-top: -1.25rem;
      width: 5rem;
      height: 5rem;
  `};
  ${props =>
    props.type === 'employeeDirectory' &&
    `top:${rem('-4px')}; 
         left:${rem('-27px')};`};
  ${props =>
    props.small &&
    ` 
      width: ${rem('40px')};
      height: ${rem('40px')};
    `};
  ${mediaqueries.lessThan('mobile')`
      height:${rem('52px')};
      width:${rem('52px')};
      ${props =>
        props.small &&
        ` 
          width: ${rem('36px')};
          height: ${rem('36px')};
        `};
      ${props =>
        props.small &&
        props.type === 'agenda' &&
        ` 
          top: ${rem('-5px')};
          left: ${rem('-6px')};
        `};
      ${props =>
        props.type === 'menuofday' &&
        ` height:${rem('42px')};
          width:${rem('42px')};
          left: ${rem('-11px')};
          top: ${rem('-9px')};
      `};
      ${props =>
        props.type === 'employeeDirectory' &&
        `top:${rem('-4px')}; 
         left:${rem('-27px')};`};
      ${props =>
        props.type === 'resumen' &&
        ` top: ${props.small && rem('-15px')};
     
  `};
  `};
`;

const StyledIconPng = styled(IconPng)`
  position: absolute;
  left: ${rem('-22px')};
  ${props =>
    props.type === 'audiences' &&
    ` bottom: ${props.small ? rem('-6px') : rem('-11px')};
      width: ${props.small && rem('51px')};
  `};
  ${props =>
    props.type === 'ranking' &&
    ` bottom: ${props.small ? rem('-6px') : rem('-11px')};
      width: ${props.small && rem('51px')};
  `};
  ${props =>
    props.type === 'pressrelease' &&
    ` bottom: ${rem('-6px')};
      width: ${rem('54px')};
  `};
  ${props =>
    props.type === 'menuofday' &&
    `bottom:${rem('-9px')};
     width:${rem('64px')};
     height:${rem('64px')};
     left: ${rem('-23px')};
  `};
  ${props =>
    props.type === 'resumen' &&
    ` top: ${props.small ? rem('-6px') : rem('-13px')};
      width: ${props.small && rem('51px')};
  `};
  ${props =>
    props.type === 'shortcut' &&
    ` top:${rem('-9px')};
  `};
  ${props =>
    props.type === 'agenda' &&
    `background-color: ${props.theme.colors.light};
    top:${rem('-6px')};
  `};
  ${props =>
    props.type === 'zerowaste' &&
    `margin-left: -0.75rem;
      margin-top: -1.25rem;
      width: 5rem;
      height: 5rem;
  `};
  ${props =>
    props.type === 'customWidget' &&
    `margin-left: -0.75rem;
      margin-top: -1.25rem;
      width: 5rem;
      height: 5rem;
  `};
  ${props =>
    props.type === 'employeeDirectory' &&
    `top:${rem('-4px')}; 
         left:${rem('-27px')};`};
  ${props =>
    props.small &&
    ` 
      width: ${rem('40px')};
      height: ${rem('40px')};
    `};
  ${mediaqueries.lessThan('mobile')`
      height:${rem('52px')};
      width:${rem('52px')};
      ${props =>
        props.small &&
        ` 
          width: ${rem('36px')};
          height: ${rem('36px')};
        `};
      ${props =>
        props.small &&
        props.type === 'agenda' &&
        ` 
          top: ${rem('-5px')};
          left: ${rem('-6px')};
        `};
      ${props =>
        props.type === 'menuofday' &&
        ` height:${rem('42px')};
          width:${rem('42px')};
          left: ${rem('-11px')};
          top: ${rem('-9px')};
      `};
      ${props =>
        props.type === 'employeeDirectory' &&
        `top:${rem('-4px')}; 
         left:${rem('-27px')};`};
      ${props =>
        props.type === 'resumen' &&
        ` top: ${props.small && rem('-15px')};
     
  `};
  `};
`;

const StyledText = styled.div`
  font-size: ${props => (props.small ? rem('16px') : rem('24px'))};
  font-family: ${props => props.theme.fonts.bold};
  text-transform: uppercase;
  color: ${props => props.theme.colors.dark};
  letter-spacing: ${rem('-0.8px')};
  line-height: ${props => (props.small ? rem('23px') : rem('40px'))};

  ${mediaqueries.lessThan('mobile')`
    font-size: ${rem('15px')};
    line-height: ${rem('30px')};
  `};

  ${mediaqueries.greaterThan('desktop')`
    font-size: ${props => (props.small ? rem('20px') : rem('24px'))};
    line-height: ${props => (props.small ? rem('32px') : rem('40px'))};
  `};
`;

export { StyledTitle, StyledIcon, StyledIconPng, StyledText };
